import { dataLayerPushWithEvent } from './callcustomevent';

export const emitMoeEvent = (moeEventName: string, moeEventAttributes: any = {}) => {
  dataLayerPushWithEvent('moe_event', {
    moe_event_name: moeEventName,
    moe_event_data: moeEventAttributes
  });
};